<template>
    <router-view />
</template>

<script>
import { watch } from 'vue';
import { useUserStore } from '@/stores/userStore';
import { useDashboardStore } from '@/stores/dashboardStore';

export default {
    setup() {
        const userStore = useUserStore();
        const dashboardStore = useDashboardStore();

        watch(
            () => userStore.isAuthenticated,
            (isAuth) => {
                if (!isAuth) {
                    dashboardStore.$reset(); // Сброс, если пользователь вышел
                }
            }
        );
    },
}
</script>